import * as React from 'react'

import Grid from '@material-ui/core/Grid'

import { FormikFormChunkProps } from '../../../types'
import { EnhancedTextField }    from '../../atoms'
import { mapFormikToMuiProps }  from '../form-utils'
import { AppointmentFields }    from '../types'

const SessionScheduleChunk: React.SFC<FormikFormChunkProps<AppointmentFields>> = props => {
  const mapper = mapFormikToMuiProps(props)

  return (
    <Grid container spacing={16}>
      <Grid item xs={12}>
        <EnhancedTextField
          fullWidth
          type={'datetime-local'}
          InputLabelProps={{ shrink: true }}
          {...mapper('date')}
        />
      </Grid>
    </Grid>
  )
}

export default SessionScheduleChunk



// WEBPACK FOOTER //
// ./src/components/forms/chunks/SessionScheduleChunk.tsx